// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"daff0579","497":"a7478173","977":"d971d651"}[chunkId] + ".chunk.js";
};